import React, { useState, useEffect, useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useRouter from 'utils/useRouter'
import { Menu, MenuItem, withStyles, ListItemIcon, ListItemText } from '@material-ui/core'
import LockIcon from '@material-ui/icons/Lock'
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn'
import GavelIcon from '@material-ui/icons/Gavel'
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd'
import AssignmentLateIcon from '@material-ui/icons/AssignmentLate'
import AttachmentIcon from '@material-ui/icons/Attachment'
import BlockIcon from '@material-ui/icons/Block'
import EditIcon from '@material-ui/icons/Edit'
import CancelIcon from '@material-ui/icons/Cancel'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import PostAddIcon from '@material-ui/icons/PostAdd'
import PublishIcon from '@material-ui/icons/Publish'
import AutorenewIcon from '@material-ui/icons/Autorenew'
import AddCommentIcon from '@material-ui/icons/AddComment'
import SupervisedUserCircleIcon from '@material-ui/icons/SupervisedUserCircle'
import CloudDownloadIcon from '@material-ui/icons/CloudDownload'
import CloudUploadIcon from '@material-ui/icons/CloudUpload'

import { ModalGerenciarAcesso } from 'components/ModalGerenciarAcesso'
import { useUsuarioService } from 'hooks/useUsuarioService'
import { useExameSolicitadoService } from 'hooks/useExameSolicitadoService'
import { useExameRealizadoService } from 'hooks/useExameRealizadoService'
import { useVestigioService } from 'hooks/useVestigioService'
import { useCadaverService } from 'hooks/useCadaverService'
import { usePericiandoService } from 'hooks/usePericiandoService'
import { useVeiculoService } from 'hooks/useVeiculoService'
import { useLocal } from 'hooks/useLocal'
import constants from 'utils/constants'
import { useFormState } from 'hooks/useFormState'
import { setIdExameRealizado, setIdExameSolicitado, criarAlerta } from 'actions'
import { useAuth } from 'hooks/useAuth'
import { CustomButton, ModalAlerta } from 'components'
import { useStyles } from './MenuAcoes.styles'

// Novos Modais Modularizados
import { ModalAtribuirExaminador } from './components/ModalAtribuirExaminador'
import { ModalDesvincularExaminador } from './components/ModalDesvincularExaminador'
import { ModalUploadExame } from './components/ModalUploadExame'
import { ModalVincularObjeto } from './components/ModalVincularObjeto'
import { ModalConfirmarAcao } from './components/ModalConfirmarAcao'
import { ModalPublicarExame } from './components/ModalPublicarExame'
import { ModalAlterarPrivacidade } from './components/ModalAlterarPrivacidade'

import { getVestigioRestricoes } from 'utils/helpers'

const tiposDeExame = require('../../../../../globals/tiposDeExame')

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
))

const StyledMenuItem = withStyles((theme) => ({
  root: {
    '&:focus': {
      backgroundColor: theme.palette.secondary.main,
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem)

export const MenuAcoes = (props) => {
  const { exameSolicitado, usuarioState, permissaoAcoesExaminador, permissaoAssumirExame, isObjetosAssociados, listarExameSolicitado } = props

  const classes = useStyles()
  const router = useRouter()
  const dispatch = useDispatch()
  const { verificarPermissao, verificarSetor } = useAuth()

  const usuarioService = useUsuarioService()
  const exameRealizadoService = useExameRealizadoService()
  const exameSolicitadoService = useExameSolicitadoService()
  const vestigioService = useVestigioService()
  const cadaverService = useCadaverService()
  const periciandoService = usePericiandoService()
  const veiculoService = useVeiculoService()
  const localService = useLocal()

  const [anchorEl, setAnchorEl] = useState(null)
  const [isAssumirOpen, setIsAssumirOpen] = useState(false)
  const [isPublicarExameOpen, setIsPublicarExameOpen] = useState(false)
  const [isAtribuirOpen, setIsAtribuirOpen] = useState(false)
  const [isGerenciarAcessoOpen, setIsGerenciarAcessoOpen] = useState(false)
  const [isDesvincularOpen, setIsDesvincularOpen] = useState(false)
  const [novosExaminadores, setNovosExaminadores] = useState([])
  const examinadoresCandidatos = useSelector((state) => state.exameSolicitado.examinadoresCandidatos)
  const [processandoExaminadoresCandidatos, setProcessandoExaminadoresCandidatos] = useState(false)
  const [processandoAtribuirExaminador, setProcessandoAtribuirExaminador] = useState(false)
  const [mensagensAlerta, setMensagensAlerta] = useState([])
  const [openAlert, setOpenAlert] = useState(false)
  const [isUsuarioExaminadorDoExame, setIsUsuarioExaminadorDoExame] = useState(false)
  const [processandoPublicarExame, setProcessandoPublicarExame] = useState(false)
  const [processandoDownload, setProcessandoDownload] = useState(false)
  const [processandoAssumirExame, setProcessandoAssumirExame] = useState(false)
  const [processandoRealizarExame, setProcessandoRealizarExame] = useState(false)

  const [vestigiosDoCaso, setVestigiosDoCaso] = useState([])
  const [processandoVestigiosDoCaso, setProcessandoVestigiosDoCaso] = useState(false)
  const [cadaveresDoCaso, setCadaveresDoCaso] = useState([])
  const [processandoCadaveresDoCaso, setProcessandoCadaveresDoCaso] = useState(false)
  const [periciandosDoCaso, setPericiandosDoCaso] = useState([])
  const [processandoPericiandosDoCaso, setProcessandoPericiandosDoCaso] = useState(false)
  const [veiculosDoCaso, setVeiculosDoCaso] = useState([])
  const [processandoVeiculosDoCaso, setProcessandoVeiculosDoCaso] = useState(false)
  const [locaisDoCaso, setLocaisDoCaso] = useState([])
  const [processandoLocaisDoCaso, setProcessandoLocaisDoCaso] = useState(false)
  const [listaObjetosDoCaso, setListaObjetosDoCaso] = useState([])
  const [objetoSelecionado, setObjetoSelecionado] = useState(null)
  const [isVincularObjetoOpen, setIsVincularObjetoOpen] = useState(false)
  const [processandoVincularObjeto, setProcessandoVincularObjeto] = useState(false)

  const [openUpload, setOpenUpload] = useState(false)
  const [processandoUploadDocumento, setProcessandoUploadDocumento] = useState(false)
  const [arquivosUpload, setArquivosUpload] = useState([])

  const [processandoAtualizacaoTemplate, setProcessandoAtualizacaoTemplate] = useState(false)
  const [isAbandonarOpen, setIsAbandonarOpen] = useState(false)
  const [processandoDesvincularExaminador, setProcessandoDesvincularExaminador] = useState(false)
  const [listaExaminadores, setListaExaminadores] = useState([])
  const [examinadoresDesvincularSelecionado, setExaminadoresDesvincularSelecionado] = useState([])
  const [isPrivateSelect, setIsPrivateSelect] = useState(false)
  const [justificativaPrivacidade, setJustificativaPrivacidade] = useState('')
  const [isAlterarPrivacidadeOpen, setIsAlterarPrivacidadeOpen] = useState(false)
  const [processandoAlterarPrivacidade, setProcessandoAlterarPrivacidade] = useState(false)

  const verificarObjetoPericiadoEmTipoExame = useCallback((objeto, tipoExame) => {
    if (tipoExame?.objetosPericia && tipoExame?.objetosPericia.includes(objeto)) {
      return true
    }
    return false
  }, [])

  const carregarObjetosDoCasoParaVinculo = useCallback(async () => {
    const idCaso = exameSolicitado?.solEx?.id_caso
    const tipoEx = exameSolicitado?.tipoEx
    if (!idCaso || !tipoEx) return

    const promessas = []
    if (verificarObjetoPericiadoEmTipoExame('VESTIGIO', tipoEx)) {
      promessas.push(vestigioService.listarVestigiosDeCasoAsync(idCaso, setProcessandoVestigiosDoCaso).then((res) => setVestigiosDoCaso(res || [])))
    }
    if (verificarObjetoPericiadoEmTipoExame('CADAVER', tipoEx)) {
      promessas.push(cadaverService.listarCadaveresDeCasoAsync(idCaso, setProcessandoCadaveresDoCaso).then((res) => setCadaveresDoCaso(res || [])))
    }
    if (verificarObjetoPericiadoEmTipoExame('PERICIANDO', tipoEx)) {
      promessas.push(periciandoService.listarPericiandosDeCasoAsync(idCaso, setProcessandoPericiandosDoCaso).then((res) => setPericiandosDoCaso(res || [])))
    }
    if (verificarObjetoPericiadoEmTipoExame('VEICULO', tipoEx)) {
      promessas.push(veiculoService.listarVeiculosDeCasoAsync(idCaso, setProcessandoVeiculosDoCaso).then((res) => setVeiculosDoCaso(res || [])))
    }
    if (verificarObjetoPericiadoEmTipoExame('LOCAL', tipoEx)) {
      promessas.push(localService.listarLocaisDeCasoAsync(idCaso, setProcessandoLocaisDoCaso).then((res) => setLocaisDoCaso(res || [])))
    }

    await Promise.all(promessas)
  }, [exameSolicitado?.solEx?.id_caso, exameSolicitado?.tipoEx, verificarObjetoPericiadoEmTipoExame])

  const examinadoresCandidatosDisponiveis = useMemo(() => {
    const idsAtribuidos = new Set((exameSolicitado?.exReal?.usuExams || []).map((u) => u.id))
    const vistos = new Set()
    return (examinadoresCandidatos || []).filter((candidato) => {
      if (!candidato?.id || idsAtribuidos.has(candidato.id) || vistos.has(candidato.id)) {
        return false
      }
      vistos.add(candidato.id)
      return true
    })
  }, [examinadoresCandidatos, exameSolicitado?.exReal?.usuExams])

  const fetchtListaObjetosDoCaso = useCallback(() => {
    if (exameSolicitado) {
      let objetos = []

      if (verificarObjetoPericiadoEmTipoExame('VEICULO', exameSolicitado.tipoEx)) {
        objetos = objetos.concat(
          veiculosDoCaso.map((veiculo) => {
            veiculo.flag = 'VEICULO'
            return veiculo
          })
        )
      }
      if (verificarObjetoPericiadoEmTipoExame('VESTIGIO', exameSolicitado.tipoEx)) {
        if (vestigiosDoCaso.length) {
          objetos = objetos.concat(
            getVestigioRestricoes(vestigiosDoCaso, exameSolicitado.tipoEx).map((vestigio) => {
              vestigio.flag = 'VESTIGIO'
              return vestigio
            })
          )
        }
      }
      if (verificarObjetoPericiadoEmTipoExame('CADAVER', exameSolicitado.tipoEx)) {
        objetos = objetos.concat(
          cadaveresDoCaso.map((cadaver) => {
            cadaver.flag = 'CADAVER'
            return cadaver
          })
        )
      }
      if (verificarObjetoPericiadoEmTipoExame('PERICIANDO', exameSolicitado.tipoEx)) {
        objetos = objetos.concat(
          periciandosDoCaso.map((periciando) => {
            periciando.flag = 'PERICIANDO'
            return periciando
          })
        )
      }
      if (verificarObjetoPericiadoEmTipoExame('LOCAL', exameSolicitado.tipoEx)) {
        objetos = objetos.concat(
          locaisDoCaso.map((local) => {
            local.flag = 'LOCAL'
            return local
          })
        )
      }

      setListaObjetosDoCaso(objetos)
    }
  }, [exameSolicitado, veiculosDoCaso, vestigiosDoCaso, cadaveresDoCaso, periciandosDoCaso, locaisDoCaso, verificarObjetoPericiadoEmTipoExame])

  useEffect(() => {
    fetchtListaObjetosDoCaso()
  }, [fetchtListaObjetosDoCaso])

  const verificarUsuarioExaminadorExameSolicitado = (usuario, exameSolicitado) => {
    let result = false
    if (exameSolicitado && exameSolicitado.exReal && exameSolicitado.exReal.usuExams) {
      exameSolicitado.exReal.usuExams.forEach((examinador) => {
        if (examinador.id === usuario.id) {
          result = true
        }
      })
    }
    return result
  }

  useEffect(() => {
    if (exameSolicitado && usuarioState) {
      setIsUsuarioExaminadorDoExame(verificarUsuarioExaminadorExameSolicitado(usuarioState, exameSolicitado))
      setListaExaminadores(exameSolicitado.exReal?.usuExams || [])
    }
  }, [exameSolicitado, usuarioState])

  const handleEditarExame = async () => {
    if (exameSolicitado && exameSolicitado.tipoEx) {
      setProcessandoRealizarExame(true)
      await exameRealizadoService.setarExameParaEndamento(exameSolicitado.exReal.id)
      dispatch(setIdExameRealizado(exameSolicitado.exReal.id))

      if (exameSolicitado.exReal && exameSolicitado.exReal.versaoDocumento > 0) {
        router.history.push(`/casos/caso/solicitacao/exameSolicitado/editorExameRealizado/${exameSolicitado.exReal.id}`)
      } else {
        switch (exameSolicitado.tipoEx.cod) {
          case tiposDeExame.NECROSCOPICO:
            router.history.push(`/casos/caso/solicitacao/exameSolicitado/edicaoExameNecroscopico/${exameSolicitado.exReal.id}`)
            break
          case tiposDeExame.NECRO_ODONTO:
            router.history.push(`/casos/caso/solicitacao/exameSolicitado/edicaoExameNecrodontoscopico/${exameSolicitado.exReal.id}`)
            break
          case tiposDeExame.ACHADO_CADAVER:
          case tiposDeExame.TRAFEGO:
          case tiposDeExame.INCENDIO:
          case tiposDeExame.ENGENHARIA_LEGAL:
            router.history.push(`/casos/caso/solicitacao/exameSolicitado/edicaoExameAchadoCadaver/${exameSolicitado.exReal.id}`)
            break
          case tiposDeExame.IMOVEL:
            router.history.push(`/casos/caso/solicitacao/exameSolicitado/edicaoExameImovel/${exameSolicitado.exReal.id}`)
            break
          case tiposDeExame.AMBIENTAL:
            router.history.push(`/casos/caso/solicitacao/exameSolicitado/edicaoExameAmbiental/${exameSolicitado.exReal.id}`)
            break
          case tiposDeExame.TENTATIVA_HOMICIDIO:
            router.history.push(`/casos/caso/solicitacao/exameSolicitado/edicaoExameTentativaHomicidio/${exameSolicitado.exReal.id}`)
            break
          case tiposDeExame.NECROPAPILOSCOPIA:
            router.history.push(`/casos/caso/solicitacao/exameSolicitado/edicaoExameNecropapiloscopico/${exameSolicitado.exReal.id}`)
            break
          case tiposDeExame.IDENTIFICACAO_CADAVERICA:
            router.history.push(`/casos/caso/solicitacao/exameSolicitado/edicaoExameIdentificacaoCadaverica/${exameSolicitado.exReal.id}`)
            break
          case tiposDeExame.CONSTATACAO:
            router.history.push(`/casos/caso/solicitacao/exameSolicitado/edicaoExameConstatacao/${exameSolicitado.id}/${exameSolicitado.exReal.id}`)
            break
          case tiposDeExame.CONFIRMACAO_IDENTIDADE:
          case tiposDeExame.IDENTIFICACAO_INFRACIONAL:
          case tiposDeExame.IDENTIFICACAO_CRIMINAL:
            router.history.push(`/casos/caso/solicitacao/exameSolicitado/edicaoExameComparacao/${exameSolicitado.exReal.id}`)
            break
          case tiposDeExame.EFICIENCIA_BALISTICA:
            router.history.push(`/casos/caso/solicitacao/exameSolicitado/edicaoExameEficienciaBalistica/${exameSolicitado.id}/${exameSolicitado.exReal.id}`)
            break
          case tiposDeExame.COINCIDENCIA_PERFIS_BALISTICO:
            router.history.push(`/casos/caso/solicitacao/exameSolicitado/edicaoExameCoincidenciaPerfis/${exameSolicitado.id}/${exameSolicitado.exReal.id}`)
            break
          case tiposDeExame.CONFRONTO_BALISTICO:
            router.history.push(`/casos/caso/solicitacao/exameSolicitado/edicaoExameConfrontoBalistico/${exameSolicitado.id}/${exameSolicitado.exReal.id}`)
            break
          case tiposDeExame.INFO_TECNICA_SINAB:
            router.history.push(`/casos/caso/solicitacao/exameSolicitado/edicaoInfoSINAB/${exameSolicitado.id}/${exameSolicitado.exReal.id}`)
            break
          case tiposDeExame.IDENTIFICACAO_BALISTICA:
            router.history.push(`/casos/caso/solicitacao/exameSolicitado/edicaoExameIdentificacaoBalistica/${exameSolicitado.id}/${exameSolicitado.exReal.id}`)
            break
          case tiposDeExame.MAUS_TRATOS:
            router.history.push(`/casos/caso/solicitacao/exameSolicitado/edicaoExameMausTratos/${exameSolicitado.id}/${exameSolicitado.exReal.id}`)
            break
          case tiposDeExame.QUIMICO_OUTRAS_SUBSTANCIAS:
          case tiposDeExame.QUIMICO_MATERIAL_DIVERSO:
          case tiposDeExame.PESQUISA_THC_COCAINA:
          case tiposDeExame.QUIMICO_PESQUISA_AGROTOXICOS:
          case tiposDeExame.QUIMICO_PESQUISA_SOLVENTES:
          case tiposDeExame.QUIMICO_PRODUTO_FARMACEUTICO:
          case tiposDeExame.QUIMICO_PESQUISA_INFLAMAVEIS:
          case tiposDeExame.QUIMICO_RESIDUOS_INCENDIO:
            router.history.push(`/casos/caso/solicitacao/exameSolicitado/edicaoExameQuimico/${exameSolicitado.id}/${exameSolicitado.exReal.id}`)
            break
          default:
            await exameRealizadoService.atualizarTemplateExame(exameSolicitado.exReal.id, setProcessandoAtualizacaoTemplate)
            router.history.push(`/casos/caso/solicitacao/exameSolicitado/editorExameRealizado/${exameSolicitado.exReal.id}`)
            break
        }
      }
      setProcessandoRealizarExame(false)
    }
  }

  const handlePublicarExame = async () => {
    setIsPublicarExameOpen(false)
    setAnchorEl(null)
    const dadosPrivacidade = {
      isPrivate: isPrivateSelect,
      justificativaPrivacidade: isPrivateSelect ? justificativaPrivacidade : null,
    }
    await exameRealizadoService.publicarExameRealizado(exameSolicitado.exReal.id, setProcessandoPublicarExame, dadosPrivacidade)
    listarExameSolicitado()
  }

  const handleDownloadPDF = async () => {
    try {
      await exameRealizadoService.downloadArquivoDocumento(exameSolicitado.exReal.id, exameSolicitado.exReal.numeroExame, setProcessandoDownload)
    } catch (err) {
      if (err.response && err.response.status === 403) {
        dispatch(
          criarAlerta({
            status: 403,
            data: { error: { innerError: { message: 'Você não tem permissão para realizar o download deste documento.' } } },
          })
        )
      } else {
        dispatch(criarAlerta(err.response || err))
      }
    }
  }

  const clickBotaoAssumirExame = () => {
    const novasMensagensAlerta = []

    if (exameSolicitado.exReal.status !== 'Pendente') {
      novasMensagensAlerta.push('O status do exame precisa estar "Pendente"')
    }
    if (!verificarPermissao([constants.PERMISSOES.ASSUMIR_EXAME_SOLICITADO])) {
      novasMensagensAlerta.push('Você não tem permissão para realizar essa operação')
    }
    if (!verificarSetor([exameSolicitado.setor.id])) {
      novasMensagensAlerta.push('Você não pertence ao setor responsável pelo exame')
    }
    if (exameSolicitado.exReal.usuExams && exameSolicitado.exReal.usuExams.length) {
      novasMensagensAlerta.push('Este exame já foi atribuido')
    }

    if (novasMensagensAlerta.length) {
      setMensagensAlerta(novasMensagensAlerta)
      setOpenAlert(true)
    } else {
      setMensagensAlerta([])
      setIsAssumirOpen(true)
    }
  }

  const assumirExame = async () => {
    if (processandoAssumirExame) return
    setAnchorEl(null)
    await exameSolicitadoService.assumirExame(exameSolicitado.id, exameSolicitado.tipoEx.cod, setProcessandoAssumirExame)
    setIsAssumirOpen(false)
    listarExameSolicitado()
  }

  const handleAbandonarExame = async () => {
    setAnchorEl(null)
    setIsAbandonarOpen(false)
    await exameSolicitadoService.abandonarExame(exameSolicitado.id)
    listarExameSolicitado()
  }

  const handleClickBotaoAtribuirExaminadores = () => {
    if (
      ((exameSolicitado.exReal.status === 'Em andamento' || exameSolicitado.exReal.status === 'Pendente') && verificarPermissao([constants.PERMISSOES.ATRIBUIR_EXAMINADOR_SUPERIOR])) ||
      (verificarPermissao([constants.PERMISSOES.ATRIBUIR_EXAMINADORES_EXAME_SOLICITADO]) && isUsuarioExaminadorDoExame && (exameSolicitado.exReal.status === 'Em andamento' || exameSolicitado.exReal.status === 'Pendente'))
    ) {
      setMensagensAlerta([])
      setAnchorEl(null)
      setNovosExaminadores([])
      setIsAtribuirOpen(true)
      if (!examinadoresCandidatos || examinadoresCandidatos.length === 0) {
        usuarioService.listarExaminadoresCandidatos(setProcessandoExaminadoresCandidatos)
      }
    } else {
      const novasMensagensAlerta = []
      if (!verificarPermissao([constants.PERMISSOES.ATRIBUIR_EXAMINADOR_SUPERIOR])) {
        novasMensagensAlerta.push('Você não tem permissão para atribuir examinador')
      }
      if (!isUsuarioExaminadorDoExame) {
        novasMensagensAlerta.push('Você não é um dos examinadores deste exame')
      }
      if (!(exameSolicitado.exReal.status === 'Em andamento' || exameSolicitado.exReal.status === 'Pendente')) {
        novasMensagensAlerta.push('O status do exame precisar estar "Pendente" ou "Em andamento"')
      }
      setMensagensAlerta(novasMensagensAlerta)
      setOpenAlert(true)
    }
  }

  const handleAtribuirExame = async () => {
    if (processandoAtribuirExaminador || !novosExaminadores.length) return
    setAnchorEl(null)
    if (verificarPermissao([constants.PERMISSOES.ATRIBUIR_EXAMINADOR_SUPERIOR])) {
      await exameSolicitadoService.atribuirExaminadoresSuperior(
        exameSolicitado.id,
        exameSolicitado.tipoEx.cod,
        novosExaminadores,
        setProcessandoAtribuirExaminador
      )
    } else {
      await exameSolicitadoService.atribuirExaminadores(
        exameSolicitado.id,
        exameSolicitado.tipoEx.cod,
        novosExaminadores,
        setProcessandoAtribuirExaminador
      )
    }
    setIsAtribuirOpen(false)
    setNovosExaminadores([])
    listarExameSolicitado()
  }

  const handleClickBotaoDesvincularExaminadores = () => {
    const novasMensagensAlerta = []

    if (!verificarPermissao([constants.PERMISSOES.ATRIBUIR_EXAMINADOR_SUPERIOR])) {
      novasMensagensAlerta.push('Você não tem permissão para desvincular examinador')
    }
    if (exameSolicitado?.exReal?.usuExams?.length < 1) {
      novasMensagensAlerta.push('Não há examinadores atribuídos!')
    }
    if (!(exameSolicitado.exReal.status === 'Em andamento' || exameSolicitado.exReal.status === 'Pendente')) {
      novasMensagensAlerta.push('O status do exame precisar estar "Pendente" ou "Em andamento"')
    }

    if (novasMensagensAlerta.length) {
      setMensagensAlerta(novasMensagensAlerta)
      setOpenAlert(true)
    } else {
      setMensagensAlerta([])
      setIsDesvincularOpen(true)
    }
  }

  const handleDesvincularExaminador = useCallback(async () => {
    setIsDesvincularOpen(false)
    setAnchorEl(null)
    await exameRealizadoService.desvincularExaminador(exameSolicitado?.exReal.id, examinadoresDesvincularSelecionado, setProcessandoDesvincularExaminador)
    setExaminadoresDesvincularSelecionado([])
    listarExameSolicitado()
  }, [exameSolicitado, examinadoresDesvincularSelecionado])

  const handleClickBotaoVincularObjeto = useCallback(() => {
    const novasMensagensAlerta = []
    if (!verificarPermissao([constants.PERMISSOES.VINCULAR_VESTIGIO_EXAME_SOLICITADO])) {
      novasMensagensAlerta.push('Você não tem permissão para realizar esta operação')
    }
    if (!(exameSolicitado?.exReal.status === 'Pendente' || exameSolicitado?.exReal.status === 'Em andamento')) {
      novasMensagensAlerta.push('O status do exame precisa estar "Pendente" ou "Em andamento"')
    }
    if (novasMensagensAlerta.length) {
      setMensagensAlerta(novasMensagensAlerta)
      setOpenAlert(true)
    } else {
      setMensagensAlerta([])
      setAnchorEl(null)
      setIsVincularObjetoOpen(true)
      carregarObjetosDoCasoParaVinculo()
    }
    setObjetoSelecionado(null)
  }, [exameSolicitado, carregarObjetosDoCasoParaVinculo])

  const handleConfirmarVincularObjeto = async () => {
    setIsVincularObjetoOpen(false)
    setAnchorEl(null)
    await exameSolicitadoService.vincularObjetoDoCaso(exameSolicitado.id, objetoSelecionado, setProcessandoVincularObjeto)
    listarExameSolicitado()
  }

  const handleClickBotaoRealizarExame = () => {
    const novasMensagensAlerta = []
    if (!verificarPermissao([constants.PERMISSOES.REALIZAR_EXAME])) {
      novasMensagensAlerta.push('Você não tem permissão para realizar esta operação')
    }
    if (!isUsuarioExaminadorDoExame && !(usuarioState.cargo.id === 1)) {
      novasMensagensAlerta.push('Você não é um dos examinadores deste exame')
    }
    if (!(exameSolicitado.exReal.status === 'Em andamento') && !(exameSolicitado.exReal.status === 'Finalizado')) {
      novasMensagensAlerta.push('O status do exame precisar estar "Em Andamento"')
    }
    if (!exameSolicitado?.tipoEx?.objetosPericia.includes('N/A') && !isObjetosAssociados) {
      novasMensagensAlerta.push('Nenhum objeto foi associado ao exame solicitado.')
    }

    if (novasMensagensAlerta.length) {
      setMensagensAlerta(novasMensagensAlerta)
      setOpenAlert(true)
    } else {
      setMensagensAlerta([])
      handleEditarExame()
    }
  }

  const handleUploadDocumento = () => {
    const novasMensagensAlerta = []
    if (!verificarPermissao([constants.PERMISSOES.REALIZAR_EXAME])) {
      novasMensagensAlerta.push('Você não tem permissão para realizar esta operação')
    }
    if (!exameSolicitado?.tipoEx?.objetosPericia.includes('VESTIGIO') && !exameSolicitado?.tipoEx?.objetosPericia.includes('N/A') && !isObjetosAssociados) {
      novasMensagensAlerta.push('Nenhum objeto foi associado ao exame solicitado.')
    }
    if (!isUsuarioExaminadorDoExame && !(usuarioState.cargo.id === 1)) {
      novasMensagensAlerta.push('Você não é um dos examinadores deste exame')
    }

    if (novasMensagensAlerta.length) {
      setMensagensAlerta(novasMensagensAlerta)
      setOpenAlert(true)
    } else {
      setMensagensAlerta([])
      setOpenUpload(true)
    }
  }

  const handleConfirmUpload = async () => {
    try {
      setAnchorEl(null)
      setOpenUpload(false)
      await exameRealizadoService.finalizarDocumentoPorUpload(exameSolicitado?.exReal.id, arquivosUpload, setProcessandoUploadDocumento)
      setArquivosUpload([])
      listarExameSolicitado()
    } catch (err) {
      console.log(err)
    }
  }

  const handleClickBotaoPublicarExame = () => {
    const novasMensagensAlerta = []
    if (!verificarPermissao([constants.PERMISSOES.PUBLICAR_EXAME_REALIZADO])) {
      novasMensagensAlerta.push('Você não tem permissão para realizar essa operação')
    }
    if (!(exameSolicitado.exReal.status === 'Finalizado')) {
      novasMensagensAlerta.push('O status do exame precisar estar "Finalizado"')
    }
    if (!isUsuarioExaminadorDoExame && !verificarPermissao([constants.PERMISSOES.PUBLICAR_EXAME_REALIZADO_OUTRO_SETOR])) {
      novasMensagensAlerta.push('Você precisa ter a permissão de publicar exame de outro usuário, caso não seja o examinador')
    }

    if (novasMensagensAlerta.length) {
      setMensagensAlerta(novasMensagensAlerta)
      setOpenAlert(true)
    } else {
      setMensagensAlerta([])
      setIsPublicarExameOpen(true)
    }
  }

  const handleClickBotaoAbandonarExame = () => {
    const novasMensagensAlerta = []
    if (!verificarPermissao([constants.PERMISSOES.ASSUMIR_EXAME_SOLICITADO])) {
      novasMensagensAlerta.push('Você não tem permissão para realizar esta operação')
    }
    if (!isUsuarioExaminadorDoExame) {
      novasMensagensAlerta.push('Você não é um dos examinadores atribuídos')
    }
    if (!(exameSolicitado.exReal.status === 'Em andamento')) {
      novasMensagensAlerta.push('O status do exame precisa estar "Em andamento"')
    }

    if (novasMensagensAlerta.length) {
      setMensagensAlerta(novasMensagensAlerta)
      setOpenAlert(true)
    } else {
      setMensagensAlerta([])
      setIsAbandonarOpen(true)
    }
  }

  const handleClickBotaoDownloadPDF = () => {
    const novasMensagensAlerta = []
    if (!(exameSolicitado.exReal.status === 'Publicado' || (isUsuarioExaminadorDoExame && exameSolicitado.exReal.status === 'Finalizado'))) {
      novasMensagensAlerta.push('O status do exame precisa estar "Publicado"')
    }

    if (novasMensagensAlerta.length) {
      setMensagensAlerta(novasMensagensAlerta)
      setOpenAlert(true)
    } else {
      setMensagensAlerta([])
      handleDownloadPDF()
    }
  }

  const handleClickBotaoCancelarExame = () => {
    const novasMensagensAlerta = []
    if (!verificarSetor([exameSolicitado.setor.id])) {
      novasMensagensAlerta.push('Você não pertence ao setor responsável pelo exame')
    }
    if (!(exameSolicitado?.exReal.status === 'Pendente' || exameSolicitado?.exReal.status === 'Em andamento')) {
      novasMensagensAlerta.push('O status do exame precisa estar "Pendente" ou "Em andamento"')
    }
    if (novasMensagensAlerta.length) {
      setMensagensAlerta(novasMensagensAlerta)
      setOpenAlert(true)
    } else {
      setMensagensAlerta([])
      router.history.push(`/casos/caso/exameSolicitado/cancelarExame/${exameSolicitado.id}/${exameSolicitado.exReal.id}`)
    }
  }

  const handleClickBotaoEditarExame = () => {
    const novasMensagensAlerta = []
    if (!(exameSolicitado?.exReal.status === 'Pendente')) {
      novasMensagensAlerta.push('O status do exame precisa estar "Pendente"')
    }
    if (novasMensagensAlerta.length) {
      setMensagensAlerta(novasMensagensAlerta)
      setOpenAlert(true)
    } else {
      setMensagensAlerta([])
      dispatch(setIdExameSolicitado(exameSolicitado?.id))
      router.history.push(`/casos/caso/solicitacao/editarexame/${exameSolicitado.id}`)
    }
  }

  const handleOpenAlterarPrivacidade = () => {
    setIsPrivateSelect(exameSolicitado.isPrivate)
    setJustificativaPrivacidade(exameSolicitado.justificativaPrivacidade || '')
    setIsAlterarPrivacidadeOpen(true)
    setAnchorEl(null)
  }

  const handleAlterarPrivacidade = async () => {
    await exameSolicitadoService.editarPrivacidadeExameSolicitado(exameSolicitado.id, isPrivateSelect, justificativaPrivacidade, setProcessandoAlterarPrivacidade)
    setIsAlterarPrivacidadeOpen(false)
    listarExameSolicitado()
  }

  const handleChangeNovoExaminador = (event, newValue) => {
    const vistos = new Set()
    const novaListaExaminadores = (newValue || []).filter((novoExaminador) => {
      if (!novoExaminador?.id || vistos.has(novoExaminador.id)) {
        return false
      }
      vistos.add(novoExaminador.id)
      return true
    })
    setNovosExaminadores(novaListaExaminadores)
  }

  const handleClickAdicionarInformacao = () => {
    dispatch(setIdExameSolicitado(exameSolicitado.id))
    router.history.push(`/exameSolicitado/adicionarInformacao/${exameSolicitado.id}`)
  }

  const handleClickBotaoCriarErrata = () => {
    const novasMensagensAlerta = []
    if (!isUsuarioExaminadorDoExame && !(usuarioState.cargo.id === 1)) {
      novasMensagensAlerta.push('Você não é um dos examinadores deste exame')
    }
    if (novasMensagensAlerta.length) {
      setMensagensAlerta(novasMensagensAlerta)
      setOpenAlert(true)
    } else {
      setMensagensAlerta([])
      router.history.push(`/casos/caso/solicitacao/exameSolicitado/editorErrata/${exameSolicitado.exReal.id}`)
    }
  }

  return (
    <>
      <CustomButton aria-controls="customized-menu" aria-haspopup="true" onClick={(e) => setAnchorEl(e.currentTarget)} endIcon={<ArrowDropDownIcon />} colorType="primary">
        Ações
      </CustomButton>

      <StyledMenu id="customized-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        <div>
          {exameSolicitado?.exReal?.status === 'Pendente' && (
            <StyledMenuItem onClick={clickBotaoAssumirExame} disabled={processandoAssumirExame}>
              <ListItemIcon>
                <AssignmentTurnedInIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Assumir exame</ListItemText>
            </StyledMenuItem>
          )}

          {verificarPermissao([constants.PERMISSOES.ADMINISTRAR_SISTEMA]) && (
            <StyledMenuItem
              onClick={() => {
                setAnchorEl(null)
                router.history.push(`/casos/caso/solicitacao/exameSolicitado/alterarStatus/${exameSolicitado.id}`)
              }}
            >
              <ListItemIcon>
                <GavelIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Alterar Status</ListItemText>
            </StyledMenuItem>
          )}

          <StyledMenuItem onClick={handleClickBotaoAtribuirExaminadores} disabled={processandoAtribuirExaminador}>
            <ListItemIcon>
              <AssignmentIndIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Atribuir examinador</ListItemText>
          </StyledMenuItem>

          <StyledMenuItem onClick={handleClickBotaoDesvincularExaminadores}>
            <ListItemIcon>
              <AssignmentLateIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Desvincular examinador</ListItemText>
          </StyledMenuItem>

          <StyledMenuItem disabled={processandoVincularObjeto} onClick={handleClickBotaoVincularObjeto}>
            <ListItemIcon>
              <AttachmentIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Vincular objeto</ListItemText>
          </StyledMenuItem>

          {(exameSolicitado?.exReal?.status === 'Em andamento' || exameSolicitado?.exReal?.status === 'Finalizado') && (
            <StyledMenuItem onClick={handleClickBotaoRealizarExame} disabled={processandoRealizarExame}>
              <ListItemIcon>
                <EditIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Realizar exame</ListItemText>
            </StyledMenuItem>
          )}

          {(exameSolicitado?.exReal?.status === 'Em andamento' || exameSolicitado?.exReal?.status === 'Finalizado') && (
            <StyledMenuItem onClick={handleUploadDocumento}>
              <ListItemIcon>
                <CloudUploadIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Upload de Exame (PDF)</ListItemText>
            </StyledMenuItem>
          )}

          {(exameSolicitado?.exReal?.status === 'Em andamento' || exameSolicitado?.exReal?.status === 'Finalizado') && (
            <StyledMenuItem disabled={processandoPublicarExame} onClick={handleClickBotaoPublicarExame}>
              <ListItemIcon>
                <PublishIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Publicar Exame</ListItemText>
            </StyledMenuItem>
          )}

          <StyledMenuItem onClick={handleClickBotaoAbandonarExame}>
            <ListItemIcon>
              <CancelIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Abandonar exame</ListItemText>
          </StyledMenuItem>

          <StyledMenuItem onClick={handleClickBotaoDownloadPDF} disabled={processandoDownload}>
            <ListItemIcon>
              <CloudDownloadIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Download PDF</ListItemText>
          </StyledMenuItem>

          <StyledMenuItem onClick={handleClickAdicionarInformacao}>
            <ListItemIcon>
              <AddCommentIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Adicionar Informação</ListItemText>
          </StyledMenuItem>

          {exameSolicitado?.exReal?.status === 'Publicado' && (
            <StyledMenuItem onClick={handleClickBotaoCriarErrata}>
              <ListItemIcon>
                <PostAddIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Criar errata</ListItemText>
            </StyledMenuItem>
          )}

          <StyledMenuItem onClick={handleClickBotaoEditarExame}>
            <ListItemIcon>
              <AutorenewIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Alterar Dados do Exame</ListItemText>
          </StyledMenuItem>

          <StyledMenuItem onClick={handleClickBotaoCancelarExame}>
            <ListItemIcon>
              <BlockIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Cancelar Exame</ListItemText>
          </StyledMenuItem>

          {(verificarPermissao(['ALTERAR_PRIVACIDADE_EXAME_SOLICITADO']) || isUsuarioExaminadorDoExame || usuarioState?.cargo?.id === 1) && (
            <StyledMenuItem onClick={handleOpenAlterarPrivacidade}>
              <ListItemIcon>
                <LockIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Alterar Privacidade</ListItemText>
            </StyledMenuItem>
          )}

          {exameSolicitado?.isPrivate && (usuarioState?.cargo?.id === 1 || isUsuarioExaminadorDoExame || exameSolicitado?.solEx?.id_autoridade_requisitante === usuarioState?.id) && (
            <StyledMenuItem
              onClick={() => {
                setAnchorEl(null)
                setIsGerenciarAcessoOpen(true)
              }}
            >
              <ListItemIcon>
                <SupervisedUserCircleIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Conceder Acesso</ListItemText>
            </StyledMenuItem>
          )}
        </div>
      </StyledMenu>

      <ModalAtribuirExaminador
        aberto={isAtribuirOpen}
        onClose={() => {
          if (!processandoAtribuirExaminador) {
            setIsAtribuirOpen(false)
            setNovosExaminadores([])
          }
        }}
        onConfirm={handleAtribuirExame}
        processando={processandoAtribuirExaminador}
        carregandoCandidatos={processandoExaminadoresCandidatos}
        examinadoresCandidatos={examinadoresCandidatosDisponiveis}
        novosExaminadores={novosExaminadores}
        onChangeNovoExaminador={handleChangeNovoExaminador}
      />

      <ModalDesvincularExaminador
        aberto={isDesvincularOpen}
        onClose={() => setIsDesvincularOpen(false)}
        onConfirm={handleDesvincularExaminador}
        processando={processandoDesvincularExaminador}
        listaExaminadores={listaExaminadores}
        examinadoresDesvincularSelecionado={examinadoresDesvincularSelecionado}
        setExaminadoresDesvincularSelecionado={setExaminadoresDesvincularSelecionado}
      />

      <ModalUploadExame
        aberto={openUpload}
        onClose={() => {
          setOpenUpload(false)
          setArquivosUpload([])
        }}
        onConfirm={handleConfirmUpload}
        processando={processandoUploadDocumento}
        arquivosUpload={arquivosUpload}
        setArquivosUpload={setArquivosUpload}
      />

      <ModalVincularObjeto
        aberto={isVincularObjetoOpen}
        onClose={() => setIsVincularObjetoOpen(false)}
        onConfirm={handleConfirmarVincularObjeto}
        processando={processandoVincularObjeto}
        carregandoObjetos={processandoVestigiosDoCaso || processandoCadaveresDoCaso || processandoVeiculosDoCaso || processandoPericiandosDoCaso || processandoLocaisDoCaso}
        listaObjetosDoCaso={listaObjetosDoCaso}
        objetoSelecionado={objetoSelecionado}
        setObjetoSelecionado={setObjetoSelecionado}
      />

      <ModalConfirmarAcao aberto={isAssumirOpen} onClose={() => setIsAssumirOpen(false)} onConfirm={assumirExame} processando={processandoAssumirExame} titulo="Assumir exame" mensagem="Você tem certeza que deseja assumir esse exame?" confirmarColor="secondary" />

      <ModalConfirmarAcao aberto={isAbandonarOpen} onClose={() => setIsAbandonarOpen(false)} onConfirm={handleAbandonarExame} titulo="Abandonar exame" mensagem="Tem certeza que deseja abandonar este exame?" confirmarColor="error" />

      <ModalPublicarExame
        aberto={isPublicarExameOpen}
        onClose={() => setIsPublicarExameOpen(false)}
        onConfirm={handlePublicarExame}
        processando={processandoPublicarExame}
        isPrivateSelect={isPrivateSelect}
        setIsPrivateSelect={setIsPrivateSelect}
        justificativaPrivacidade={justificativaPrivacidade}
        setJustificativaPrivacidade={setJustificativaPrivacidade}
      />

      <ModalAlterarPrivacidade
        aberto={isAlterarPrivacidadeOpen}
        onClose={() => setIsAlterarPrivacidadeOpen(false)}
        onConfirm={handleAlterarPrivacidade}
        processando={processandoAlterarPrivacidade}
        isPrivateSelect={isPrivateSelect}
        setIsPrivateSelect={setIsPrivateSelect}
        justificativaPrivacidade={justificativaPrivacidade}
        setJustificativaPrivacidade={setJustificativaPrivacidade}
      />

      <ModalAlerta aberto={openAlert} onClose={() => setOpenAlert(false)} titulo="Requisitos não atendidos" mensagens={mensagensAlerta} tipo="erro" />

      <ModalGerenciarAcesso open={isGerenciarAcessoOpen} onClose={() => setIsGerenciarAcessoOpen(false)} idCaso={exameSolicitado?.solEx?.id_caso} usuarios={[]} selecionados={[]} />
    </>
  )
}

export default MenuAcoes
